// Copyright 2026 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { z } from 'zod';
import { DEFAULT_STITCH_API_URL } from '../constants.js';
// ─────────────────────────────────────────────────────────────────────────────
// 1. INPUT SCHEMA
// ─────────────────────────────────────────────────────────────────────────────
export const StitchProxyConfigSchema = z.object({
    /** API key for Stitch authentication. Falls back to STITCH_API_KEY. */
    apiKey: z.string().optional(),
    /** Access token for Stitch authentication (Bearer). Falls back to STITCH_ACCESS_TOKEN. */
    accessToken: z.string().optional(),
    /** Quota project ID for billing. Required with accessToken auth. Falls back to STITCH_PROJECT_ID or GOOGLE_CLOUD_PROJECT. */
    quotaProjectId: z.string().optional(),
    /** Target Stitch MCP URL. Default: https://stitch.googleapis.com/mcp */
    url: z.string().default(DEFAULT_STITCH_API_URL),
    /** Name of the local proxy server. Default: stitch-proxy */
    name: z.string().default('stitch-proxy'),
    /** Version of the local proxy server. Default: 1.0.0 */
    version: z.string().default('1.0.0'),
    /** Protocol version to use for Stitch JSON-RPC connection. Default: '2024-11-05' */
    protocolVersion: z.string().default('2024-11-05'),
});
//# sourceMappingURL=proxy.js.map